<section class="listings-sitemap" *ngIf="links">
  <div class="links-header">
    <h1 class="title">{{ 'listing-sitemap.title' | translate }}</h1>
    <h3 class="headline">{{ 'listing-sitemap.headline1' | translate }}<br>{{ 'listing-sitemap.or' | translate }}<a routerLink="/find-real-estate">{{ 'listing-sitemap.headline2' | translate }}</a></h3>
  </div>
  <div class="sitemap-links">
    <h2 class="title">{{ 'listing-sitemap.links-title' | translate }}</h2>
    <div class="headers">
      <span class="address">{{ 'listing-sitemap.links-headers.address' | translate }}</span>
      <span class="price">{{ 'listing-sitemap.links-headers.price' | translate }}</span>
      <span class="bedBathSqft">{{ 'listing-sitemap.links-headers.bedBathSqft' | translate }}</span>
      <span class="lastUpdated">{{ 'listing-sitemap.links-headers.dateAdded' | translate }}</span>
    </div>
    <div #sitemapLinksList class="links" *ngFor="let link of links">
      <a class="links" [routerLink]="['../' + link.detailUrl]">
        <span class="address"><span class="link-blue">{{link.address}}, {{link.city}}, {{link.state}}</span>{{(link.isForRent? 'listing-sitemap.links-body.for-rent' : 'listing-sitemap.links-body.for-sale') | translate}}</span>
        <span class="price link-blue">{{link.price | currency : 'CAD':'symbol-narrow':'1.0-0'}}</span>
        <span class="bedBathSqft link-blue">{{link.bedsBathSqFt}}</span>
        <span class="lastUpdated link-blue">{{link.initialIngestionDate | date }}</span>
      </a>
    </div>
  </div>
  <div class="pagination">
    <app-pagination [isListingSitemap]="true" [totalPages]="pagination.totalPages" [currentPageNumber]="pagination.pageNumber"></app-pagination>
  </div>
</section>
